(function () {
  'use strict';
  if (window.gpsMeasurement) return;
  const config = document.getElementById('gps-measurement-script');
  if (!config || (window.Shopify && Shopify.designMode)) return;
  const events = new Set(['faq_open', 'product_option_change', 'cart_attempt', 'cart_error', 'contact_click', 'contact_submit_success', 'info_open', 'comparison_interaction', 'gallery_ready', 'gallery_image_view', 'gallery_depth']);
  const fields = new Set(['faq_id', 'faq_topic', 'option_name', 'option_value', 'option_index', 'option_choice', 'contact_channel', 'contact_topic', 'source_section', 'error_type', 'info_topic', 'interaction', 'quantity', 'product_template', 'image_position', 'gallery_depth', 'gallery_size']);
  const context = {
    product_id: config.dataset.productId || '',
    product_handle: config.dataset.productHandle || '',
    page_type: config.dataset.pageType || 'other',
    product_template: config.dataset.productTemplate || 'default',
    measurement_version: '1.1.0'
  };
  function allowed() {
    try { return window.Shopify.customerPrivacy.analyticsProcessingAllowed() === true; }
    catch (_) { return false; }
  }
  function emit(name, parameters) {
    try {
      if (!events.has(name) || !allowed()) return false;
      const data = Object.assign({event_name: name}, context);
      Object.entries(parameters || {}).forEach(([key, value]) => {
        if (!fields.has(key)) return;
        if (typeof value === 'number' && Number.isFinite(value)) data[key] = value;
        else if (typeof value === 'string' && /^[a-zA-Z0-9_-]{1,100}$/.test(value)) data[key] = value;
      });
      if (window.Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Promise.resolve(Shopify.analytics.publish('gps_winkel:interaction', data)).catch(() => {});
      }
      if (typeof window.clarity === 'function') {
        window.clarity('event', name);
        if (name === 'faq_open' && data.faq_topic) window.clarity('event', 'faq_open_' + data.faq_topic);
      }
      return true;
    } catch (_) { return false; }
  }
  window.gpsMeasurement = Object.freeze({emit, version: '1.1.0'});
  function topic(text) {
    const s = (text || '').toLowerCase();
    if (/abonnement|maandelijks|terugkerend|extra kosten/.test(s)) return 'subscription';
    if (/lever|bezorg|verzend/.test(s)) return 'delivery';
    if (/retour|terugstuur|proberen|testen/.test(s)) return 'returns';
    if (/garantie|niet werkt/.test(s)) return 'warranty';
    if (/apple|android|apparaten|telefoon/.test(s)) return 'compatibility';
    if (/delen|meerdere personen/.test(s)) return 'sharing';
    if (/install|koppel/.test(s)) return 'installation';
    if (/werkt|werking/.test(s)) return 'how_it_works';
    return 'other';
  }
  function section(el) {
    if (el.closest('.faq-section,.gps-contact-faq')) return 'faq';
    if (el.closest('.cmp-section')) return 'comparison';
    if (el.closest('footer,.footer')) return 'footer';
    if (el.closest('header,.header')) return 'header';
    if (el.closest('#stickyAtc')) return 'sticky';
    if (el.closest('.gps-contact')) return 'contact_page';
    return context.page_type === 'product' ? 'product' : 'other';
  }
  function contentOpening(readOpen, parameters) {
    if (context.page_type !== 'product' || !allowed() || readOpen() !== false) return;
    setTimeout(() => {
      if (readOpen() === true) emit('info_open', Object.assign({interaction: 'open'}, parameters));
    }, 0);
  }
  window.addEventListener('click', function (event) {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;
    const descriptionButton = target.closest('#desc-more-btn');
    if (descriptionButton) {
      const wrap = descriptionButton.closest('.desc-more-wrap');
      if (wrap) contentOpening(() => wrap.isConnected ? wrap.classList.contains('open') : null, {info_topic: 'product_information', source_section: 'product_description'});
    }
    const specificationsButton = target.closest('.specs-toggle-btn');
    if (specificationsButton) {
      const table = specificationsButton.closest('.specs-section')?.querySelector('.specs-table');
      if (table && table.rows.length > 6) contentOpening(() => specificationsButton.isConnected ? specificationsButton.getAttribute('data-expanded') === 'true' && Array.from(table.rows).slice(6).some(row => row.style.display !== 'none') : null, {info_topic: 'specifications', source_section: 'product_specifications'});
    }
    const summary = target.closest('summary');
    const details = summary?.parentElement;
    if (details?.matches('details') && details.closest('.feature-accordion,.product__accordion,.collapsible-content')) {
      contentOpening(() => details.isConnected ? details.open : null, {info_topic: details.matches('.feature-acc-item') ? 'product_feature' : 'product_information', source_section: details.matches('.feature-acc-item') ? 'product_features' : 'product_accordion'});
    }
    const question = target.closest('.faq-question,.gps-faq-q');
    if (question) {
      const item = question.parentElement;
      const wasOpen = item.classList.contains('open');
      setTimeout(() => {
        if (!wasOpen && item.classList.contains('open')) {
          emit('faq_open', {faq_id: item.dataset.gpsFaqId || 'contact_' + Array.from(item.parentElement.children).indexOf(item), faq_topic: topic(question.textContent), source_section: section(question)});
        }
      }, 0);
    }
    const link = target.closest('a[href]');
    if (link) {
      let url;
      try { url = new URL(link.href, location.origin); } catch (_) { return; }
      let channel;
      if (['wa.me', 'api.whatsapp.com', 'web.whatsapp.com'].includes(url.hostname)) channel = 'whatsapp';
      else if (url.protocol === 'mailto:') channel = 'email';
      else if (url.protocol === 'tel:') channel = 'phone';
      else if (url.origin === location.origin && /\/pages\/contact\/?$/.test(url.pathname)) channel = 'contact_page';
      if (channel) emit('contact_click', {contact_channel: channel, source_section: section(link)});
      const policies = {'/pages/retourneren': 'returns', '/pages/bestelling-levering': 'delivery', '/pages/betaalmogelijkheden': 'payment', '/pages/algemene-voorwaarden': 'terms'};
      if (url.origin === location.origin && policies[url.pathname.replace(/\/$/, '')]) emit('info_open', {info_topic: policies[url.pathname.replace(/\/$/, '')], source_section: section(link)});
    }
    if (target.closest('.cmp-info-button,.tag-info-button')) emit('info_open', {info_topic: 'trial', source_section: section(target)});
    if (target.closest('.cmp-section .btn-expand')) emit('comparison_interaction', {interaction: 'toggle_specifications', source_section: 'comparison'});
    if (target.closest('#tag-expand-applications')) emit('product_option_change', {option_name: 'extra_tags', option_value: 'toggle'});
    if (target.closest('#tag-add-person')) emit('product_option_change', {option_name: 'person', option_value: 'add'});
    if (target.closest('.tag-remove-person')) emit('product_option_change', {option_name: 'person', option_value: 'remove'});
    const quantity = target.closest('#smarttag-configurator [data-delta]');
    if (quantity) emit('product_option_change', {option_name: 'extra_quantity', option_value: Number(quantity.dataset.delta) > 0 ? 'increase' : 'decrease'});
  }, true);
  window.addEventListener('change', function (event) {
    const el = event.target;
    if (!(el instanceof Element)) return;
    if (context.page_type === 'product' && allowed() && el.matches('[id^="cmp-detail-toggle-"]') && el.checked) {
      const comparison = el.closest('.cmp-section');
      setTimeout(() => {
        if (el.isConnected && el.checked && comparison?.classList.contains('cmp-details-open')) emit('info_open', {info_topic: 'specifications', source_section: 'comparison', interaction: 'open'});
      }, 0);
    }
    if (el.matches('[name="smarttag-device"]')) emit('product_option_change', {option_name: 'phone', option_value: el.value === 'Android' ? 'android' : 'apple'});
    else if (el.matches('[name="tag-base-pack"]') && ['2', '4'].includes(el.value)) emit('product_option_change', {option_name: 'pack', option_value: el.value});
    else if (el.matches('.pdp-variant-select')) emit('product_option_change', {option_name: 'variant', option_index: Number(el.dataset.optionIndex), option_choice: el.selectedIndex});
    else if (el.matches('.tag-purpose input[type="checkbox"]')) emit('product_option_change', {option_name: 'application', option_value: el.checked ? 'selected' : 'deselected'});
    else if (el.matches('[id^="cmp-diff-toggle-"]')) emit('comparison_interaction', {interaction: el.checked ? 'differences_only' : 'all_differences', source_section: 'comparison'});
  }, true);
  const pendingContact = 'gps_measurement_contact_pending';
  window.addEventListener('submit', function (event) {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (form.querySelector('input[name="form_type"][value="contact"]') && allowed()) {
      const select = form.querySelector('select[name="contact[body]"]');
      const topics = ['general', 'product', 'delivery', 'returns_warranty', 'installation'];
      try { sessionStorage.setItem(pendingContact, JSON.stringify({time: Date.now(), topic: select ? topics[select.selectedIndex] || 'other' : 'other'})); } catch (_) {}
    }
    if (/\/cart\/add(?:\.js)?$/.test(new URL(form.action, location.origin).pathname) && !document.getElementById('smarttag-configurator') && !form.closest('product-form')) emit('cart_attempt', {source_section: section(form)});
  }, true);
  function contactSuccess() {
    if (!allowed() || !document.querySelector('[data-gps-contact-success]')) return;
    try {
      const raw = sessionStorage.getItem(pendingContact);
      sessionStorage.removeItem(pendingContact);
      if (!raw) return;
      const pending = JSON.parse(raw);
      if (Date.now() - pending.time < 1800000) emit('contact_submit_success', {contact_topic: pending.topic, contact_channel: 'form', source_section: 'contact_page'});
    } catch (_) {}
  }
  document.addEventListener('visitorConsentCollected', contactSuccess);
  if (window.Shopify && typeof Shopify.loadFeatures === 'function') Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], error => { if (!error) contactSuccess(); });
  contactSuccess();
})();

